import { Component, ElementRef, OnInit, Renderer2 } from '@angular/core';
import { CtrlBaseComponent } from '../ctrl-base.component';
import { cardType } from '../../enums/cardType.enum';

@Component({
  selector: 'lib-ct-card',
  templateUrl: './ct-card.component.html',
  styleUrls: ['./ct-card.component.css']
})
export class CtCardComponent extends CtrlBaseComponent implements OnInit {

  //Properties
  private title : string;
  private type : cardType;
  private description: string;
  private clipboardValue : string;

  //clipboardProperties
  public isTooltipShown: boolean = false;

  //Util
  public cardType = cardType;

  constructor(private renderer: Renderer2, private el: ElementRef) { 
    super();
  }
  ngOnInit(): void {
    super.ngOnInit();
  }

  changeTooltipWindowState(): void {
    this.isTooltipShown = !this.isTooltipShown;
  setTimeout(() => {
        this.isTooltipShown = !this.isTooltipShown;
    }, 3000); 
}

  //Logica correspondiente al Type Clipboard
  copyToClipboard(clipboardValue: string): void {
    const input = this.renderer.createElement('input');
    this.renderer.setAttribute(input, 'value', clipboardValue);
    this.renderer.appendChild(this.el.nativeElement, input);
    input.select();
    document.execCommand('copy');
    this.renderer.removeChild(this.el.nativeElement, input);
    this.changeTooltipWindowState();
  }
  //GETTERS
  getTitle(): string { return this.title }
  getType(): cardType { return this.type }
  getDescription(): string {return this.description}
  getClipboardValue(): string {return this.clipboardValue}

  //SETTERS
  setTitle(title: string): void {this.title = title}
  setType(type: cardType ) { this.type = type}
  setDescription(description: string): void {this.description = description}
  setClipboardValue(clipboardValue: string): void {this.clipboardValue = clipboardValue}
}

